const RANKING = [
  { rank: 1, title: '星辰大海', subtitle: '都市情感励志剧 · 全网热度第一', tag: '热播', tagColor: 'accent' },
  { rank: 2, title: '极限挑战第十季', subtitle: '户外真人秀 · 笑点密集', tag: '新季', tagColor: 'primary' },
  { rank: 3, title: '流浪地球3', subtitle: '国产科幻巨制 · 4K蓝光画质', tag: '高分', tagColor: 'secondary' },
  { rank: 4, title: '青春有你5', subtitle: '偶像竞演综艺 · 话题不断', tag: '热播', tagColor: 'accent' },
  { rank: 5, title: '鬼灭之刃 锻刀村篇', subtitle: '热血日漫 · 豆瓣9.2分', tag: '推荐', tagColor: 'primary' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            热播榜单
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            实时热度排行，大家都在看的精彩内容
          </p>
        </div>
        <div className="max-w-3xl mx-auto space-y-2">
          {RANKING.map((item) => {
            const tagBg =
              item.tagColor === 'accent'
                ? 'bg-accent-500/15 text-accent-400 border-accent-500/20'
                : item.tagColor === 'secondary'
                  ? 'bg-secondary-500/15 text-secondary-400 border-secondary-500/20'
                  : 'bg-primary-500/15 text-primary-400 border-primary-500/20';
            const rankColor =
              item.rank === 1
                ? 'text-primary-400'
                : item.rank === 2
                  ? 'text-accent-400'
                  : item.rank === 3
                    ? 'text-secondary-400'
                    : 'text-foreground-500';
            return (
              <div
                key={item.rank}
                className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-300/15 hover:border-background-300/30 transition-all cursor-pointer group"
              >
                <div className={`w-10 h-10 flex items-center justify-center font-heading font-black text-xl ${rankColor} flex-shrink-0`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5 truncate">
                    {item.subtitle}
                  </p>
                </div>
                <span className={`flex-shrink-0 px-2.5 py-1 text-xs font-medium rounded-full border whitespace-nowrap ${tagBg}`}>
                  {item.tag}
                </span>
                <div className="w-7 h-7 flex items-center justify-center flex-shrink-0 text-foreground-600 group-hover:text-primary-400 transition-colors">
                  <i className="ri-play-circle-line text-lg"></i>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}